import { render, staticRenderFns } from "./venue.vue?vue&type=template&id=29ee5b20&scoped=true&"
import script from "./venue.vue?vue&type=script&lang=js&"
export * from "./venue.vue?vue&type=script&lang=js&"
import style0 from "./venue.vue?vue&type=style&index=0&id=29ee5b20&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ee5b20",
  null
  
)

export default component.exports